import type { TreeAccordionCaretPosition } from 'ui-components';
import { useFlags } from './amplitude/client';
import { FLAG_TREATMENT, Flags } from './flagConstants';
import type { FlagVariant } from './index';

/**
 * Whether the SSR search category tree renders its expand caret before the
 * label (`Flags.SEARCH_CATEGORY_CARET_START`, CPS-8475). Falls back to `key`
 * because the REST client (`AmplitudeHttpRemoteEvaluationClient`) returns
 * variants without `value`.
 */
export const isSearchCategoryCaretStart = (variant?: FlagVariant): boolean =>
  (variant?.value ?? variant?.key) === FLAG_TREATMENT;

/** Reads the server-resolved variant through `FlagsProvider`, so the server
 *  HTML and the hydrated tree share one layout. */
export const useSearchCategoryCaretPosition = (): TreeAccordionCaretPosition =>
  isSearchCategoryCaretStart(
    useFlags().flags?.[Flags.SEARCH_CATEGORY_CARET_START]
  )
    ? 'start'
    : 'end';
